import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-autosave',
  template: `
    <div class="autosave" [ngClass]="{ 'disabled': disabled }" >
      <div class="autosave__container" >
        <ng-container *ngIf="!disabled" >
          <ion-item lines="none" >
            <ion-label>
              {{ 'generic.automaticSave' | translate }}
            </ion-label>
            <ion-toggle
              color="primary"
              [checked]="true"
              (ionChange)="setAutoSave($event.detail.checked)"
            ></ion-toggle>
          </ion-item>

          <div>
            <ion-spinner
              *ngIf="saveAllowed && isSaving"
              name="crescent"
              color="primary"
            ></ion-spinner>

            <ion-icon
              name="save"
              [color]="saveAllowed && (!isSaving && !pendingChanges) ? 'success' : 'gray'"
            ></ion-icon>
          </div>
        </ng-container>

        <div class="autosave__container--disabled" *ngIf="disabled" >
          {{ 'managerEvaluation.autoSaveDisabled' | translate }}
        </div>
      </div>
    </div>`,
  styleUrls: ['./autosave.component.scss']
})
export class AutoSaveComponent {

  @Input() isSaving: boolean = false;
  @Input() pendingChanges: boolean = false;
  @Input() set setDisabled(disabled: boolean) {
    this.disabled = disabled;
    if (disabled)
      this.setAutoSave(false);
  }

  public autoSaveAllowed$ = new Subject<boolean>();
  public saveAllowed: boolean = true;
  public disabled: boolean = false;

  public setAutoSave(value: boolean) {
    this.saveAllowed = value;
    this.autoSaveAllowed$.next(value);
  }

}
